const rows = [
  {
    n: "01",
    title: "Trusted Silver Jeweller in Delhi",
    desc: "A fixture of Kucha Mahajani, Chandni Chowk — known to Delhi families by name, not by advertisement.",
  },
  {
    n: "02",
    title: "Pure & Quality Silver",
    desc: "Strictly 92.5 sterling silver. Every piece is weighed and quality-checked before it leaves the counter.",
  },
  {
    n: "03",
    title: "Unique Traditional Designs",
    desc: "Anklets, temple ornaments and heirloom neckpieces you will not find in a mass-market showroom.",
  },
  {
    n: "04",
    title: "Personalised Customer Service",
    desc: "Sit with us, describe the occasion, and we will guide you to the right piece — or craft one for you.",
  },
];

export const WhyChoose = () => {
  return (
    <section
      id="why"
      data-testid="why-section"
      className="relative py-24 lg:py-32 bg-white"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="max-w-2xl mb-16 reveal">
          <p className="text-[11px] tracking-[0.4em] uppercase text-zinc-500 mb-5">
            05 — Why Choose Us
          </p>
          <h2 className="font-display font-light text-zinc-950 text-4xl sm:text-5xl lg:text-6xl leading-[1.02] tracking-tight">
            Four quiet reasons
            <br />
            <span className="italic text-zinc-600">customers return.</span>
          </h2>
        </div>

        <div className="border-t border-zinc-200">
          {rows.map((r, i) => (
            <div
              key={r.n}
              data-testid={`why-row-${i}`}
              className={`grid grid-cols-12 gap-4 lg:gap-10 py-10 lg:py-14 border-b border-zinc-200 reveal reveal-delay-${
                (i % 4) + 1
              }`}
            >
              <div className="col-span-2 font-display text-zinc-400 text-2xl lg:text-3xl">
                {r.n}
              </div>
              <div className="col-span-10 lg:col-span-5">
                <h3 className="font-display text-2xl lg:text-3xl text-zinc-950 leading-tight">
                  {r.title}
                </h3>
              </div>
              <div className="col-span-12 lg:col-span-5 text-zinc-600 leading-relaxed">
                {r.desc}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
